<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>Vip研究生列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
        @submit.native.prevent="getList()"
      >
        <el-form-item label="搜索">
          <el-input v-model="query.key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item
          label="来源"
          label-width="80px"
          style="margin-left: -15px"
        >
          <el-select
            v-model="query.origin"
            filterable
            clearable
            @change="selList()"
          >
            <el-option
              v-for="item in sourselist"
              :label="item.name"
              :value="item.id"
              :key="item.id"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="大学"
          label-width="80px"
          style="margin-left: -15px"
        >
          <el-select
            v-model="query.college"
            filterable
            clearable
            @change="selList()"
          >
            <el-option label="请选择大学" value></el-option>
            <el-option
              v-for="item in collegeList"
              :label="item.label"
              :value="item.label"
              :key="item.label"
              placeholder="请选择"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="缴费时间"
          label-width="80px"
          style="margin-left: 8px"
        >
          <el-date-picker
            v-model="query.daterange"
            @change="selList()"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="期数">
          <el-cascader
            :options="monthList"
            filterable
            clearable
            :props="{ value:'label'}"
            @change="applayMonthChange"
          ></el-cascader>
        </el-form-item>
        <div>
          <el-form-item label="顾问" label-width="80px" style="margin-left: -15px">
            <DeptRoleTeacherSelect v-model="query.adviserID" dept="留学" placeholder="请选择顾问" @change="schoolClick()" />
          </el-form-item>
          <el-form-item label="营销" label-width="80px" style="margin-left: -15px">
            <DeptRoleTeacherSelect v-model="query.marketID" dept="留学" placeholder="请选择营销" @change="schoolClick()" />
          </el-form-item>
          <el-form-item label="文案" label-width="80px" style="margin-left: -15px">
            <DeptRoleTeacherSelect v-model="query.documentID" dept="留学" placeholder="请选择文案" @change="schoolClick()" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="selList()">查询</el-button>
            <el-button type="success" @click="exportClick()">导出</el-button>
          </el-form-item>
        </div>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>Vip研究生列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            prop="paymentDate"
            label="缴费时间"
          ></el-table-column>
          <el-table-column prop="inputTime" label="添加时间"></el-table-column>

          <el-table-column prop="realName" label="姓名"></el-table-column>
          <el-table-column prop="wechat" label="微信"></el-table-column>
          <el-table-column
            prop="adviserName"
            label="顾问"
          ></el-table-column>
          <el-table-column
            prop="documentName"
            label="文案老师"
          ></el-table-column>
          <el-table-column prop="marketName" label="营销"></el-table-column>
          <el-table-column prop="eduBack" label="学历"></el-table-column>
          <el-table-column prop="schOrigin" label="出身校"></el-table-column>
          <el-table-column prop="major" label="专业"></el-table-column>
          <el-table-column prop="japanese" label="日语"></el-table-column>
          <el-table-column prop="english" label="英语"></el-table-column>
          <el-table-column
            prop="researchSection"
            label="研究科"
          ></el-table-column>
          <el-table-column
            prop="targetCollect"
            label="合格院校"
          ></el-table-column>
          <el-table-column prop="applyTime" label="申请期数"></el-table-column>
          <el-table-column prop="firstPay" label="第一期缴费"></el-table-column>
          <el-table-column
            prop="secondPay"
            label="第二期缴费"
          ></el-table-column>
          <el-table-column prop="thirdPay" label="第三期缴费"></el-table-column>
          <el-table-column prop="isAbove" label="是否前端显示">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.isAbove == true"
                >是</el-tag
              >
              <el-tag type="warning" v-else>否</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="isExit" label="是否退出">
            <template slot-scope="scope">
              <el-tag type="primary" v-if="scope.row.isExit == true"
                >是</el-tag
              >
              <el-tag type="warning" v-else>否</el-tag>
            </template>
          </el-table-column> -->
          <!-- <el-table-column prop="reason" label="淘汰原因"></el-table-column> -->
          <el-table-column label="跟进状态" :width="150">
            <template slot-scope="scope">
              <OtherDeptFollow :row="scope.row" :show-student="false" @show-follow="showFollowDialog" />
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button-group v-if="isMarketingOnlyStu(scope.row) || isNoAdviserStu(scope.row)">
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="showstuid = scope.row.stuID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
              <el-button-group v-else>
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                    type="success"
                    size="mini"
                    icon="el-icon-view"
                    @click="showstuid = scope.row.stuID"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分配" placement="top">
                  <el-button
                    type="info"
                    size="mini"
                    icon="el-icon-user-solid"
                    @click="assignClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="top" v-if="canEditStu(scope.row)">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="评估表" placement="top" v-if="canEditStu(scope.row)">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-document"
                    @click="tabClick(scope.row.stuID)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑研究生信息' : '添加研究生信息'"
      :visible.sync="dialogVisible"
      width="60%"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="姓名"
              prop="realName"
              :rules="[{ required: true, message: '不能为空' }]"
            >
              <el-input
                readonly
                v-model="form.realName"
                placeholder="请输入姓名"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="微信号"
              prop="wechat"
              :rules="[{ required: true, message: '不能为空' }]"
            >
              <el-input
                readonly
                v-model="form.wechat"
                placeholder="请输入微信号"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="录入时间"
              prop="inputTime"
              :rules="[{ required: true, message: '不能为空' }]"
            >
              <el-date-picker
                v-model="form.inputTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="请选择录入时间"
                style="width: 100%"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="缴费时间"
              prop="paymentDate"
              :rules="[{ required: true, message: '不能为空' }]"
            >
              <el-date-picker
                v-model="form.paymentDate"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="请选择缴费时间"
              ></el-date-picker>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="12">
            <el-form-item label="申请期数">
              <el-cascader
                :options="timelist"
                v-model="selectedOptions"
                @change="abroadTimeChange"
                clearable
                :props="{ value: 'id', label: 'value' }"
                placeholder="选择留学时间"
                style="width: 100%"
              ></el-cascader>
            </el-form-item>
          </el-col> -->
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="出身校"
              prop="schOrigin"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-input v-model="form.schOrigin" placeholder="请输入来自的院校">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="专业"
              prop="major"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-input v-model="form.major" placeholder="请输入专业">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="申请期数"
              prop="applyTime"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-date-picker
                v-model="form.applyTime"
                format="yyyy-MM"
                value-format="yyyy-MM"
                type="month"
                placeholder="请选择申请期数"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item
              label="一期缴费"
              prop="firstPay"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-input
                type="number"
                v-model.number="form.firstPay"
                placeholder="请输入一期缴费"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="二期缴费"
              prop="secondPay"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-input
                type="number"
                v-model.number="form.secondPay"
                placeholder="请输入二期缴费"
              >
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="三期缴费"
              prop="thirdPay"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-input
                type="number"
                v-model.number="form.thirdPay"
                placeholder="请输入三期缴费"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item
              label="日语"
              prop="japanese"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-input v-model="form.japanese" placeholder="请输入日语等级">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="英语"
              prop="english"
              :rules="[{ required: false, message: '不能为空' }]"
            >
              <el-input v-model="form.english" placeholder="请输入英语等级">
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <template v-if="isInput == false">
            <el-col :span="8">
              <el-form-item
                label="合格院校"
                prop="targetCollect"
                :rules="[{ required: false, message: '不能为空' }]"
              >
                <el-select v-model="form.targetCollect" filterable clearable>
                  <el-option
                    v-for="item in collegeList"
                    :label="item.label"
                    :value="item.label"
                    :key="item.name"
                    placeholder="请选择"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="success" @click="isInput = true"
                >请输入</el-button
              >
            </el-col>
          </template>
          <template v-if="isInput == true">
            <el-col :span="8">
              <el-form-item
                label="合格院校"
                prop="targetCollect"
                :rules="[{ required: false, message: '不能为空' }]"
              >
                <el-input
                  v-model="form.targetCollect"
                  placeholder="请输入大学"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="success" @click="isInput = false"
                >请选择</el-button
              >
            </el-col>
          </template>
          <template v-if="isEntry == false">
            <el-col :span="8">
              <el-form-item
                label="研究科"
                prop="researchSection"
                :rules="[{ required: false, message: '不能为空' }]"
              >
                <el-select v-model="form.researchSection" filterable clearable>
                  <el-option
                    v-for="item in majorList"
                    :label="item.title"
                    :value="item.title"
                    :key="item.ID"
                    placeholder="请选择"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="warning" @click="isEntry = true"
                >请输入</el-button
              >
            </el-col>
          </template>
          <template v-if="isEntry == true">
            <el-col :span="8">
              <el-form-item
                label="研究科"
                prop="researchSection"
                :rules="[{ required: false, message: '不能为空' }]"
              >
                <el-input
                  v-model="form.researchSection"
                  placeholder="请输入研究科"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-button type="warning" @click="isEntry = false"
                >请选择</el-button
              >
            </el-col>
          </template>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="是否前端显示">
              <el-switch v-model="form.isAbove"></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否退出">
              <el-switch v-model="form.isExit"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>

        <el-divider content-position="left" style="padding: 10px 0px"
          >文案老师</el-divider
        >
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="文案老师" prop="documentID">
              <el-select
                v-model="form.documentID"
                placeholder="请选择"
                filterable
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in documentList"
                  :label="item.realName"
                  :value="item.userID"
                  :key="item.userID"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 操作对话框 评估表信息-->
    <el-dialog title="评估表信息" :visible.sync="evalDialogVisible">
      <el-form :model="eval" label-width="100px" :status-icon="true">
        <el-form-item
          label="完善地址"
          prop="link"
          :rules="[{ required: true, message: '请输入姓名' }]"
        >
          <el-input v-model="eval.link"></el-input>
        </el-form-item>

        <el-form-item>
          <a :href="eval.link" target="_blank">
            <el-button type="info">打开链接</el-button>
          </a>

          <!-- <router-link
            :to="'/assess?id=' + eval.stuid"
            :params="{ id: eval.stuid }"
            style="margin-left: 20px"
          >
            <el-button type="primary">内部完善资料</el-button>
          </router-link> -->
        </el-form-item>
        <!-- <hr> -->
        <el-form-item label="评估表" v-if="eval.isDown">
          <a target="_blank" :href="domain + eval.downLink">
            <el-button type="success">点击生成word</el-button>
          </a>
        </el-form-item>
        <el-alert
          title="完善评估表资料后即可下载！"
          type="warning"
          v-else
        ></el-alert>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="evalDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 分配资源弹框（统一组件） -->
    <AssignResourceDialog
      :visible.sync="assignDialogVisible"
      :form="assignForm"
      :adviser-list="adviserList"
      :market-list="marketList"
      :user-is-admain="userIsAdmain"
      :show-student="false"
      :show-jap="true"
      :show-mingye="true"
      name-label="学生姓名"
      empty-message="请至少选择一种资源类型（日语或鸣野）"
      @success="getList"
    />
    <FollowDetailDialog :visible.sync="followDialogVisible" :type="followType" :row="followDialogRow" />
    <StudentShow :stuid="showstuid" v-on:setzero="showstuid = 0"></StudentShow>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import dateData from "@/plugins/dateHelper.js";
import user from "@/plugins/user.js";
import StudentShow from "@/components/StudentShow";
import OtherDeptFollow from "@/components/OtherDeptFollow";
import FollowDetailDialog from "@/components/FollowDetailDialog";
import AssignResourceDialog from "@/components/AssignResourceDialog";
import DeptRoleTeacherSelect from "@/components/DeptRoleTeacherSelect.vue";
export default {
  data() {
    return {
      domain: url.getDomain(),
      userIsAdmain: user.isAdmin(), //是否是管理员
      userIsMarket: user.isMarket(), //是否是营销
      userIsAdviser: user.isAdviser(), //是否是顾问
      adviserList: [],
      documentList: [],
      marketList: [],
      sourselist: [], //来源
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      selectedOptions: [],
      timelist: [], //留学时间
      showstuid: 0,
      eval: {},
      evalDialogVisible: false,
      collegeList: [],
      majorList: [],
      isInput: false,
      isEntry: false,
      monthList: dateData.getMonthListGraduate(),
      assignForm: {},
      assignDialogVisible: false,
      followDialogVisible: false,
      followType: '',
      followDialogRow: null,
    };
  },
  components: { StudentShow, OtherDeptFollow, FollowDetailDialog, AssignResourceDialog, DeptRoleTeacherSelect },
  methods: {
    canEditStu(row) {
      return user.canEditStu(row);
    },
    isMarketingOnlyStu(row) {
      return user.isMarketingOnlyStu(row);
    },
    isNoAdviserStu(row) {
      return user.isNoAdviserStu(row);
    },
    //行样式
    tableRowClassName({ row, rowIndex }) {
      if (row.isExit === true) {
        return "exit-row";
      } 
      return "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    applayMonthChange(e){
      this.query.applyYear=e[0];
      this.query.applyMonth=e[1];
         //刷新列表
         this.getList();
    },
    //获取留学时间--月份
    getMonth: function () {
      return [
        { id: 4, value: 4 },
        { id: 10, value: 10 },
        { id: 12, value: 12 },
      ];
    },
    //选择留学时间
    abroadTimeChange() {
      this.form.applyYear = this.selectedOptions[0];
      this.form.applyMonth = this.selectedOptions[1];
    },
    //留学时间
    getTimeList() {
      var yearList = [];
      var year = new Date().getFullYear();
      var monthList = this.getMonth();
      for (var i = year; i < year + 10; i++) {
        yearList.push({
          id: i,
          value: i,
          children: monthList,
        });
      }
      this.timelist = yearList;
    },
    //导出操作
    exportClick() {
      var _this = this;
      var params = _this.query;
      params.state = _this.state;

      var result = [];
      for (var item in params) {
        if (params[item]) {
          result.push(item + "=" + params[item]);
        }
      }
      result.push("exportName=研究生学生列表");
      var link = url.getStu("ExportVip_Graduate") + "?" + result.join("&");
      //console.info(link);
      window.open(link, "_blank");
    },
    // 来源
    getAllOrigin() {
      var _this = this;
      var link = url.getCommon("GetStuParam");
      $.get(link, {}, (data) => {
        _this.sourselist = data.originParam;
      });
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      if (_this.query.daterange) {
        params.payStart = _this.query.daterange[0];
        params.payEnd = _this.query.daterange[1];
      } else {
        params.payStart = "";
        params.payEnd = "";
      }
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getStu("GetList_Graduate");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //按学校查询
    schoolClick: function () {
      this.getList();
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          //询问操作
          this.$confirm("确定要修改吗", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              var link = url.getStu("Update_Graduate");
              var info = Object.assign({}, this.form);
              info.applyYear = _this.selectedOptions[0];
              info.applyMonth = _this.selectedOptions[1];
              // console.info(info);
              //   info.noticeDate = _this.form.noticeDate + "-" + _this.form.day;
              this.submiting = true;
              //提交后台添加
              $.post(link, info, (res) => {
                _this.submiting = false;
                if (res.status) {
                  _this.dialogVisible = false;
                  _this.isInput = false;
                  _this.isEntry=false;
                  _this.getList();
                  _this.$message({
                    type: "success",
                    message: res.msg,
                  });
                } else {
                  _this.$message({
                    type: "error",
                    message: res.msg,
                  });
                }
              });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //编辑
    editClick: function (row) {
      this.form = Object.assign({}, row);
      if (this.form.inputTime && typeof this.form.inputTime === 'string' && this.form.inputTime.length > 10)
        this.form.inputTime = this.form.inputTime.substring(0, 10);
      this.dialogVisible = true;
      this.selectedOptions = [row.applyYear, row.applyMonth];
    },
    //跳转评估表
    tabClick: function (id) {
      var _this = this;
      _this.evalDialogVisible = true;
      var link = url.getStu("Get_GraLink");
      $.get(link, { id: id }, (data) => {
        _this.eval = data;
      });
    },
    showFollowDialog(type, row) {
      this.followType = type;
      this.followDialogRow = row && (row.stuID != null || row.id != null) ? { ...row, id: row.stuID || row.id } : (row || {});
      this.followDialogVisible = true;
    },
    // 分配资源
    assignClick: function (row) {
      var _this = this;
      var currentUserID = user.getInfo() && (user.getInfo().userID != null ? user.getInfo().userID : user.getInfo().Id);
      _this.assignForm = {
        id: row.id,
        studentID: row.stuID,
        realName: row.realName,
        isStudent: row.isStudent || false,
        isJap: row.isJap || false,
        isMingye: row.isMingye || false,
        resourceTypes: [],
        jpAdviserID: row.jpAdviserID || null,
        jpMarketID: _this.userIsAdmain ? (row.jpMarketID || null) : (currentUserID || null),
        myAdviserID: row.myAdviserID || null,
        myMarketID: _this.userIsAdmain ? (row.myMarketID || null) : (currentUserID || null)
      };
      _this.assignDialogVisible = true;
    },
  },
  created() {},
  mounted() {
    var _this = this;
    // 来源
    this.getAllOrigin();
    //申请期数
    this.getTimeList();
    //获取学生列表
    this.getList();
    // 顾问/营销老师：不再按板块获取，直接获取所有启用用户
    $.get(url.getStu("getenableusers"), (res) => {
      var list = res || [];
      _this.adviserList = list;
      _this.marketList = list;
    });
    $.get(url.getStu("getdocument"), (res) => {
      _this.documentList = res;
    });
    //大学专业
    $.get(url.getCommon("GetCollege"), (res) => {
      _this.collegeList = res;
    });
    $.get(url.getCommon("GetSpecial_Collete"), (res) => {
      _this.majorList = res;
    });
  },
};
</script>

